import { previewImageService } from '@pixum/3d-preview-generation';
import type { DenormalizedCreationState, PageState } from '@pixum/types';

/**
 * A factory function that creates a preview image loader for article previews in 3d.
 * @returns A function that takes a creation state and returns a preview image URL.
 */
export function createCreationPreviewImageLoader() {
  return async (creation: DenormalizedCreationState) => {
    const pageGroupUuid = creation.pagegroups[0];
    const elements = creation.pagegroupToElements[pageGroupUuid].map(
      (elementUuid: string) => creation.elementsById[elementUuid],
    );
    const layers = Object.values(creation.layersById);
    const selectedPage = creation.selectedPage ? (creation.elementsById[creation.selectedPage] as PageState) : null;
    const pageGroup = creation.selectedPagegroup ? creation.pagegroupsById[creation.selectedPagegroup] : null;

    if (selectedPage && pageGroup) {
      const customerImagePreview = await previewImageService.getPreviewImageUrl({
        createRenderLayerUrl: (uuid: string) => creation.layersById[uuid]?.content?.data?.url,
        elements,
        layers,
        selectedPage,
        pagegroup: pageGroup,
        pagegroupBoundingBox: pageGroup,
        imageQualityWarningLayers: [],
        elasticLogger: console,
      });

      return customerImagePreview ? customerImagePreview : '';
    }

    return '';
  };
}
